import { Component } from '@angular/core';

@Component({
	selector: 'ahr-settings-wrapper',
	templateUrl: './ahr-settings-wrapper.component.html'
})
export class AHRSettingsWrapperComponent {
	navLinks = [
		{
			url: 'program-year-open',
			label: 'Program Year Open',
			iconClass: ''
		},
		{
			url: 'review-dates',
			label: 'Review Dates',
			iconClass: 'fa fa-calendar'
		},
		{
			url: 'test-clock',
			label: 'Test Clock',
			iconClass: 'fa fa-clock-o'
		}
	];
}
